export default {
  title: 'Home',
  oldVersion: 'Back To Old Version',
  myConfig: 'My Configuration',
  myConfig2: 'Config',
  deviceCard: {
    deviceOverviewButton: 'Device Overview',
    newFirmwareButton: 'New Firmware',
    productDevice: 'Product/Device',
    deviceInformation: 'Device Information',
    clickToEnter: 'Click to enter',
  },
  emptyState: {
    webSupportEmpty: 'For the best experience, use the following browsers with Web Driver: ',
    webUnsupportEmpty: 'Other browsers are currently unsupported:',
    webSupporting:
      'The web driver supports the following product models. More models will be added soon.',
    webSupportListBtn: 'View full list',
    clientEmpty:
      'No device detected. Please reconnect or go to [Settings > Receiver Pairing > Pairing Detection] in the upper-right corner.',
    connectButton: 'Connect Devices',
    notFoundConfig: 'No device detected, no profile available',
    notFoundConfig2: 'The current device being operated does not have configuration functionality.',
    permissionTip1:
      'Click "Connect Devices". If you don\'t see the authorization dialog, check if your browser has restricted pop-ups for this site. Search for "Pop-ups and redirects" in your browser settings.',
    permissionTip2:
      '(Search terms may vary by browser. Please use the exact search term for your browser.) Add the current URL to the allowed list and refresh the page.',
  },
  config: {
    new: 'New Config',
    card: {
      current: 'Current',
      defaultName: 'Factory Config',
      userDefaultName: 'User Config',
      untitled: 'Unnamed',
      uploadText: 'Upload the current configuration to your account for backup.',
      downloadText: 'Download cloud configuration to overwrite the current one.',
      notLoggedInUpload: 'You must log in to your account to upload.',
      notLoggedInDownload: 'You must log in to your account to download.',
      delete: 'Delete Configuration',
      edit: 'Edit Name',
      defaultOnboard: 'Default Onboard',
      defaultOnboard1: 'Onboard Profile 1',
      defaultOnboard2: 'Onboard Profile 2',
      defaultOnboard3: 'Onboard Profile 3',
    },
    uploadDialog: {
      title: 'Upload Current Configuration File',
      deviceModelLabel: 'Device Model',
      deviceModelInput: 'Please enter the device model',
      configNameLabel: 'Configuration Name',
      configNameInput: 'Please enter a configuration name',
    },
    uploadingDialog: {
      text: 'Uploading the current configuration file to the cloud backup.',
    },
    downloadingDialog: {
      text: 'Downloading cloud files to overwrite the current configuration file.',
    },
    configListDialog: {
      title: 'List of Configuration Files',
      deleteConfirmText: 'Once deleted, items cannot be recovered and must be added again',
      footerButton: 'Download Overwrite',
    },
    deleteDialog: {
      title: 'Delete Configuration File',
      confirmText:
        'Confirm deletion of the currently used configuration file? Once deleted, it cannot be recovered. If you need to use it again, please recreate it. Cline hit repeated tool call failures. Try guiding it with a new prompt.',
      confirmText2:
        'Confirm deletion of the currently used configuration file? After deletion, it will automatically switch to the previous configuration file. Once deleted, it cannot be recovered. If you need to use it again, please recreate it. Cline hit repeated tool call failures. Try guiding it with a new prompt.',
    },
    renameDialog: {
      title: 'Rename',
      input: 'Please enter a name',
      overLimitTip: 'Name exceeds the maximum length',
    },
    gameApp: {
      title: 'Games And Apps',
      addButton: 'Add App',
      emptyText: 'To Be Added',
      appEmptyConfigText: 'Must add the configuration for devices to the app for it to take effect',
      selectFilePicker: {
        title: 'Select A Game Or App',
        filterName: 'Executable File',
        unknownFile: 'Unknown App',
      },
      deleteDialog: {
        title: 'Delete App',
        description:
          'Confirm deletion of this app. Once deleted, it cannot be recovered and must be added again.',
      },
      detailDialog: {
        title: 'App Details',
      },
    },
  },
  newVersion: {
    title: 'New Version',
    description: "There's A New Version Of A HUB!",
    latestVersion: 'Latest Version',
    updateButton: 'Update Now',
  },
  user: {
    logIn: 'Go to Login',
    login: 'Login',
    register: 'Register',
    avatarAlt: 'User Avatar',
    nickname: 'Nickname',
    username: 'Username',
    email: 'Email',
    bindEmail: 'Bind Email',
    bindWechat: 'Bind WeChat',
    logout: 'Log Out',
    changePassword: 'Change Password',
    backLoginButton: 'Back to Login',
    usernamePlaceholder: 'Username',
    emailPlaceholder: 'Email',
    emailPlaceholder2: 'Please enter your email',
    passwordPlaceholder: 'Password',
    passwordPlaceholder2: 'Please enter your password',
    oldPasswordPlaceholder: 'Current Password',
    newPasswordPlaceholder: 'New Password',
    confirmNewPasswordPlaceholder: 'Confirm New Password',
    captchaPlaceholder: 'Enter Code',
    loginTab: {
      account: 'Account Login',
      scan: 'QR Code Login',
    },
    registerTab: {
      account: 'Account Registration',
      scan: 'QR Code Registration',
    },
    validate: {
      email: 'Please enter your email',
      emailFirst: 'Please enter your email first',
      emailValid: 'Please enter a valid email address',
      emailValidFirst: 'Please enter a valid email format first',
      captcha: 'Please enter the code',
      captchaFailed: 'Code validation failed',
      captchaError: 'Incorrect code',
      oldPassword: 'Please enter your current password',
      newPassword: 'Please enter your new password',
      minPassword: 'Password must be at least 6 characters',
      maxPassword: 'Password must not exceed 20 characters',
      username: 'Please enter your username',
      usernameValid: 'Spaces, underscores, and Chinese characters are not allowed',
      password: 'Please enter your password',
      confirmPassword: 'Please confirm your password',
      passwordValid:
        '6-20 characters, uppercase/lowercase letters, numbers, and !?＠#¥%&*() are allowed; spaces, and Chinese characters are not allowed',
      passwordNotMatch: 'Passwords do not match',
      passwordNotMatch2: 'The two passwords entered do not match',
    },
    loginForm: {
      scanText: 'Use WeChat Scan to log in and bind',
      loginSuccessful: 'Login successful',
      loginFailed: 'Login failed',
      forget: 'Forgot Password',
      login: 'Log In Now',
    },
    registerForm: {
      confirmPasswordPlaceholder: 'Confirm Password',
      registerSuccessful: 'Registration successful',
      registerFailed: 'Registration failed',
      register: 'Register Now',
    },
    forgotPasswordForm: {
      title: 'Forgot Password',
      sendCaptcha: 'Send Code',
      sendCaptchaSuccessful: 'Verification code sent',
      sendCaptchaFailed: 'Failed to send code',
      resetPasswordSuccessful: 'Password reset successful, please log in again',
    },
    bindAccountDialog: {
      title: 'Bind Existing Account',
      success: 'Account bound successfully',
    },
    bindWechatDialog: {
      title: 'Bind WeChat Account',
      titie: 'Bind WeChat Account',
      description: 'Use WeChat Scan to log in and bind',
      successToast: 'WeChat bound successfully',
      error: 'Failed to parse message',
    },
    changePasswordDialog: {
      title: 'Change Password',
      successToast: 'Password changed successfully',
    },
  },
  overview: {
    baseData: {
      title: 'Basic',
      model: 'Model',
      currentConfig: 'Current Config',
      connectionType: 'Connection Type',
      firmwareVersion: 'Firmware Version',
      receiverVersion: 'Receiver Version',
      wired: 'Wired',
      wireless: 'Wireless',
      reportRate: 'Polling Rate',
      sleepTime: 'Sleep Time',
      minutes: ' min',
    },
    cfgData: {
      title: 'Parameters',
      reportRate: 'Polling Rate',
      sensorMode: 'Performance Mode',
      communicationProtocol: 'Communication Protocol',
      keyScanRate: 'Key Scan Rate',
      wirelessRF: 'RF Boost',
      motionSync: 'Motion Sync',
      linearCorrection: 'Angle Snapping',
      rippleCorrection: 'Ripple Correction',
      silentHeight: 'Lift-Off Distance',
      keyDebounce: 'Key Debounce Delay',
      keyReleaseDebounce: 'Key Release Debounce Delay',
      glassTracking: 'Glass Tracking',
      sensorAngle: 'Sensor Angle',
      pointerSpeed: 'Pointer Speed',
      wheelSpeed: 'Scroll Speed',
      sleepTime: 'Sleep Time',
      // Enum values
      protocolTurbo: 'Turbo Efficient Protocol',
      protocolInitial: 'Initial Protocol',
      rfFull: 'Full RF',
      rfSmart: 'Smart Adjust',
      on: 'On',
      off: 'Off',
      sensorModeOffice: 'Office Mode',
      sensorModeBalanced: 'Balanced Mode',
      sensorModePower: 'Power Mode',
      sensorModeHyper: 'Hyper Mode',
      sensorModeCompetition: 'Competition Hyper Mode',
      sensorModeRampage: 'Rampage Competitive Mode',
      wheelScroll: 'Scroll',
      wheelLine: 'page(s)',
      wheelPage: 'Scroll the entire page',
      minutes: 'min',
      noSleep: 'No Sleep',
    },
    dpiData: {
      title: 'DPI Settings',
      gearCount: 'Gear Count',
      currentGear: 'Current Gear',
    },
    keyRemapData: {
      title: 'Key Remapping',
    },
    rtData: {
      title: 'Button Trigger',
      triggerTravel: 'Actuation Travel',
      rapidTrigger: 'RT Travel',
      vibration: 'Vibration Feedback',
      sound: 'Sound',
      volume: 'Volume',
      leftValue: 'Left {value}',
      rightValue: 'Right {value}',
      disabledValue: '(Off)',
      feedbackValue: '{type} {value}',
      mechanicalSwitch: 'Mechanical-style Microswitch',
      opticalSwitch: 'Optical-style Microswitch',
      electromagneticSwitch: 'Electromagnetic Microswitch',
    },
    screenDisplay: {
      title: 'Screen Display',
      brightness: 'Brightness',
      imageCount: 'Image Count',
      imageUnit: 'pics',
    },
    keyboardLighting: {
      keyLight: 'Key Light',
      sideLight: 'Side Light',
      decorLight: 'Decor Light',
      chargeLight: 'Charge Light',
      effectSetting: 'Effect',
      brightness: 'Brightness',
      speed: 'Speed',
    },
    lightBand: {
      title: 'Light Band',
      lightMode: 'Light Mode',
      chargeState: 'Charge State',
      chargeLight: 'Show Charging Light',
      ambientLight: 'Show Ambient Light',
      speed: 'Speed',
      brightness: 'Brightness',
    },
    screenLogo: {
      title: 'Logo Light',
      lightMode: 'Light Mode',
      chargeState: 'Charge State',
      chargeLight: 'Show Charging Light',
      ambientLight: 'Show Ambient Light',
      speed: 'Speed',
      brightness: 'Brightness',
    },
    softwareData: {
      title: 'Software',
      currentVersion: 'Current Version',
      autoStart: 'Start on Boot',
      on: 'On',
      off: 'Off',
    },
  },
  // 游戏零售支持设备列表
  chinaGameSupportList: `
    <h3 class="text-l-medium text-black-white">Rapoo VT 2nd Generation Full Series Mouse</h3>
      <div>
        <div>
          <h4 class="text-m-medium text-black-white">Large hand:</h4>
          <p class="text-m-medium text-text-glass-default">
            VT7 MAX Master V2/VT7 AirMAX V2/VT7 PRO V2/VT7 V2/VT7 MAX/VT7;
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT3 MAX Master V2/VT3 AirMAX V2/VT3 PRO V2/VT3 V2/VT3 MAX/VT3;
          </p>
        </div>
        <div>
          <h4 class="text-m-medium text-black-white">Medium-large hand:</h4>
          <p class="text-m-medium text-text-glass-default">
            VT9 MAX Master V2/VT9 AirMAX V2/VT9 PRO V2/VT9 V2/VT9 MAX/VT9;
          </p>
          <p class="text-m-medium text-text-glass-default">VT6MAX/VT6;</p>
          <p class="text-m-medium text-text-glass-default">VT2MAX/VT2;</p>
        </div>
        <div>
          <h4 class="text-m-medium text-black-white">Small-medium hand:</h4>
          <p class="text-m-medium text-text-glass-default">
            VT9s MAX Master V2/VT9s AirMAX V2/VT9s PRO V2/VT9s V2;
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT7s MAX Master V2/VT7s AirMAX V2/VT7s PRO V2/VT7s V2;
          </p>
          <p class="text-m-medium text-text-glass-default">
            VT3s MAX Master V2/VT3s AirMAX V2/VT3s PRO V2/VT3s V2/VT3s MAX Master/VT3s AirMAX/VT3s MAX/VT3s;
          </p>
          <p class="text-m-medium text-text-glass-default">VT1 MAX/VT1;</p>
          <p class="text-m-medium text-text-glass-default">
            VT0 MAX Master/VT0 AirMAX/VT0 MAX/VT0;
          </p>
        </div>
      </div>
    <h3 class="text-l-medium text-black-white">Rapoo Wireless Gaming Accessories: P5 PLUS</h3>
  `,
}
